import { ChangeDetectorRef, Component, effect, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { SharedService } from '../shared/services/shared.service';
import { User } from '../model/user.model';
import { TranslatePipe } from '../pipes/translate.pipe';
import { ToasterService } from '../shared/services/toaster.service';
import { TokenService } from '../auth/token.service';
import { HeaderComponent } from './header/header.component';
import { ChatBoxComponent } from '../modules/chat-box/chat-box.component';
@Component({
    selector: 'app-layout',
    imports: [
        RouterOutlet,
        RouterModule,
        CommonModule,
        TranslatePipe,
        // AuthModalComponent,
        HeaderComponent,
        ChatBoxComponent
    ],
    providers: [],
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.scss'
})
export class LayoutComponent implements OnInit, OnDestroy {
  // authModalRef: NgbModalRef | undefined;
  // authPage = 'login';
  // openModal = false;
  thisYear = new Date().getFullYear();
  // @ViewChild('authModal') authModal: any;
  expandMenu = false;
  private _subscription!: Subscription;
  user: User | null = null;
  prevUrl: string = '';
  currentUrl: string = '';
  isMobileMenuActive = false;
  isSignedIn = false;
  activeTab = '';
  hideExceptTopMenu = false;
  inEmbeddedBrowser = false;
  loadCaddyData = false;
  mobileSlideMenu = false;
  
  constructor(
    private _sharedService: SharedService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object,
    private _activatedRoute: ActivatedRoute,
    private _toaster: ToasterService,
    private _tokenService: TokenService,
    private _cdr: ChangeDetectorRef
    
  ) {
    effect(() => {
      this.isSignedIn = this._sharedService.loggedIn();
    });
    
    // this._sharedService.openLoginModal$.subscribe(modal => {
    //   if (modal.status && this.authModal) {
    //     this.openAuthModal(this.authModal, modal.window);
    //   }
    // })
    router.events.subscribe((val) => {
      if (isPlatformBrowser(this.platformId)) {
        if (val instanceof NavigationEnd) {
          const navigation = this.router.getCurrentNavigation();
          this.hideExceptTopMenu = navigation?.extras.state?.['hideExceptTopMenu'] || false;
          this._cdr.markForCheck();
          this.expandMenu = false;
          this.mobileSlideMenu = false;
          this.isMobileMenuActive = false;
          if (!val.url.includes('/settings')) {
            this.activeTab = '';
          } else if (val.url.includes('?tab=MyBag')) {
            this.activeTab = 'MyBag';
          } else if (val.url.includes('?tab=MyPartner')) {
            this.activeTab = 'MyPartner';
          }
        }
      }
    });
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this._activatedRoute.queryParams.subscribe(params => {
        if (params['error']) {
          this._toaster.error(params['error'], 'Please try again');
          this.clearQueryParams();
        }
        if (params['page'] === 'register') {
          if (params['access_token'] && params['id_token'] && params['refresh_token']) {
            this._tokenService.saveTokens({
              AccessToken: params['access_token'],
              IdToken: params['id_token'],
              RefreshToken: params['refresh_token']
            });
            this.loadCaddyData = true;
            // this.getUserSetting();
          }
        }
        if (params['type'] === 'register') {
          this.router.navigate(['/register']);
        } else if (params['type'] === 'login') {
          this.router.navigate(['/login']);
        }
      });
      if (this.isEmbeddedBrowser()) {
        this.inEmbeddedBrowser = true;
      }

      this._sharedService.isMyBagActive$.subscribe(res => {
        if (res) {
          this.activeTab = res;
        }
      })
    }
  }

  clearQueryParams() {
    this.router.navigate([], {
      relativeTo: this._activatedRoute,
      queryParams: {},
      queryParamsHandling: ''
    });
  }

  navigateToSettingPage(tabName: string) {
    // this._sharedService.setByBagSettingTab(tabName);
    // this.router.navigateByUrl("/settings");
    this.router.navigate(["settings/user-settings"], {
      queryParams: { tab: tabName }, // Set the new query parameter
      queryParamsHandling: 'merge', // Merge with existing query params
    });
    this.activeTab = tabName;
    this.expandMenu = false;
    this.mobileSlideMenu = false;
    this.isMobileMenuActive = false;
  }

  isEmbeddedBrowser(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor;

    // Detect LinkedIn, Facebook, Instagram embedded browsers
    return /FBAN|FBAV|Instagram|LinkedIn/i.test(userAgent);
  }

  // openAuthModal(content: any, modalPage: string) {
  //   if (isPlatformBrowser(this.platformId)) {
  //     if (this.router.url.includes('answer') || this.router.url.includes('discover')) {
  //       localStorage.setItem('redirectUrl', this.router.url);
  //     }
  //     this.authPage = modalPage;
  //     this.authModalRef = this._modalService.open(content, { windowClass: 'auth-modal' });
  //     this.clearQueryParams();
  //   }
  // }

  // closeAuthModal(event: any) {
  //   this.authModalRef?.dismiss();
  // }

  ngOnDestroy(): void {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }
}
